<template>
  <v-app>

   <Welcomebar></Welcomebar>

   <!-- left nav drawer -->
 <v-navigation-drawer
      v-model="drawer"
      app
      :mini-variant.sync="mini"
      permanent
      dark
      floating
      disable-resize-watcher
      expand-on-hover
    >
      <v-list-item class="px-2">
        <v-list-item-avatar v-if="userIsAuthenticated">
          <v-img :src="user.profilePic"></v-img>
        </v-list-item-avatar>

        <v-list-item-title v-if="userIsAuthenticated">{{user.username}}</v-list-item-title>

      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item
          v-for="nav in navItems"
          :key="nav.title"
          link
          router :to="nav.link"
          @click.stop="checkMessage(nav.title), checkSignOut(nav.title)"
        >
          <v-list-item-icon>
            <v-icon>{{ nav.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content >
            <v-list-item-title >{{ nav.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- router view -->
    <v-content>
        <router-view :key="$route.fullPath"></router-view>
    </v-content>


    <!-- message bar -->

          <v-app-bar-nav-icon @click.stop="drawerRight = !drawerRight"></v-app-bar-nav-icon>
             <v-navigation-drawer
            v-model="drawerRight"
            src="https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg"
            app
            right
            dark
            temporary
            disable-resize-watcher
            v-if="userIsAuthenticated"
            >
            <v-row fluid class="pa-0" align="center">
            <v-btn @click="showDirect">Direct</v-btn>
            <v-btn @click="showGroup">Groups</v-btn>
            </v-row>
            <v-list v-if="!group">
        <v-list-item v-for="social in socials" :key="social.friendId" router :to="'/messages/' + social.friendId">

        <v-list-item-title v-text="newUser(social.friendId)"></v-list-item-title>
        <v-icon v-if="!notification(social.friendId)" color="red">info</v-icon>
         <v-list-item-avatar color="grey"><img :src="newProfile(social.friendId)"></v-list-item-avatar>
        </v-list-item>
        </v-list>
        <v-list v-else>
        <v-list-item v-for="d in groupDms" :key="d.chatId" router :to="'/group-chat/' + d.chatId">

          <v-list-item-title v-text="d.name"></v-list-item-title>

          <v-list-item-avatar color="grey"><img :src="d.imageUrl"></v-list-item-avatar>
        </v-list-item>
        </v-list>
    </v-navigation-drawer>


  </v-app>
</template>

<script>
import { mapActions } from 'vuex'

import Welcomebar from '@/components/Frontend/WelcomeBar.vue'
  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      drawerRight: false,
      left: false,
      mini: true,
      view: 'lg',
      group: false
    }),
    computed: {
      navItems(){
        let navItems= [
        {icon: 'lock_open', title: 'Sign In', link:'/signin'},
        {icon: 'person', title: 'Sign Up', link:'/signup'},
        ]
        if(this.userIsAuthenticated){
          navItems = [
            {icon: 'mdi-account-circle', title: 'Profile', link:'/profile'},
            {icon: 'supervisor_account', title: 'Friends', link:'/friends'},
            {icon: 'widgets', title: 'Posts', link:'/feed'},
            {icon:'mdi-message', title: 'Messages', },
            {icon:'lock', title: 'Sign Out', }
          ]
        }
        return navItems
      },
      userIsAuthenticated (){
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      },
      socials() {
        return this.$store.state.fetchFriends
      },
      groupDms(){
        return this.$store.state.fetchDms
      },
      getUser(){
        if(this.userIsAuthenticated){
          return this.$store.state.user
        }
        return null
      },
      user(){
        return this.$store.state.user
      },
    },
    methods: {
      ...mapActions(['firebaseStopGettingMessages']),
      checkMessage(title){
        if(title === 'Messages'){
         this.drawerRight= !this.drawerRight
        }
      },
      onSignOut() {
        this.$store.dispatch('signout')
      },
      newUser(social) {
        return this.$store.state.allUsers[social].username
      },
      newProfile(social) {
        return this.$store.state.allUsers[social].profilePic
      },
      checkSignOut(title){
        if(title === 'Sign Out'){
          this.$router.push('/')
          this.onSignOut();
        }
      },
      newDm(social){
        return this.$store.state.groupChat[social]
      },
      viewport(){
        this.view = this.$vuetify.breakpoint.name;
      },
      notification(social) {
         return this.$store.state.notifications[social].seen
      },
      showGroup() {
        this.group= true
      },
      showDirect() {
        this.group= false
      }

    },
    mounted() {
       this.$store.dispatch('firebaseGetGroupChat')
       this.$store.dispatch('firebaseGetDMs')
       this.$store.dispatch('firebaseGetNotifications')
    },
    created() {
      this.$vuetify.theme.dark= false
    },

    components: {
      Welcomebar,
    }

  }
</script>

<style lang="css">

  body {
    padding-top: 36px;
  }
</style>
